import React from 'react'
import { useLocation } from 'react-router-dom'
import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react'

// Breadcrumb GLOBAL del header (único en la app — las páginas NO repiten
// breadcrumb). Construye la jerarquía desde la ruta real:
//   /home               → Home / Home
//   /superadmin         → Home / SuperAdmin / Panel
//   /superadmin/empresas→ Home / SuperAdmin / Empresas
//   /prestamos          → Home / Prestamos
// El nombre de la sección de SuperAdmin se resuelve con el mapa; el resto
// se capitaliza del segmento de ruta.
const ETIQUETA_SECCION = {
  superadmin: 'SuperAdmin',
  panel: 'Panel',
  empresas: 'Empresas',
  usuarios: 'Usuarios',
  roles: 'Roles',
  planes: 'Planes',
  modulos: 'Módulos',
  paises: 'Países',
  impresoras: 'Impresoras',
  sms: 'SMS',
  sesiones: 'Sesiones',
  actualizaciones: 'Actualizaciones',
}

const capitalizar = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s)

// [RGM] 2026-10-06 (pedido Rafael: "el search del navbar y el home no están
// traduciendo según el idioma del navegador"): los textos del template se
// muestran en español cuando el navegador NO está en inglés (las empresas
// son hispanohablantes); en inglés quedan como el template.
const idiomaIngles = (navigator.language || '').toLowerCase().startsWith('en')

const AppBreadcrumb = () => {
  const currentLocation = useLocation().pathname
  const partes = currentLocation.split('/').filter(Boolean)

  // /superadmin → se muestra como "SuperAdmin / Panel" (Resumen del menú)
  let mostrar
  if (partes[0] === 'superadmin' && partes.length === 1) {
    mostrar = ['superadmin', 'panel']
  } else {
    mostrar = partes
  }

  return (
    <CBreadcrumb className="my-0">
      <CBreadcrumbItem href="/#/home">
        {idiomaIngles ? 'Home' : 'Inicio'}
      </CBreadcrumbItem>
      {mostrar.map((p, i) => (
        <CBreadcrumbItem key={p + i} active={i === mostrar.length - 1}>
          {ETIQUETA_SECCION[p] ?? capitalizar(p)}
        </CBreadcrumbItem>
      ))}
    </CBreadcrumb>
  )
}

export default React.memo(AppBreadcrumb)
